module.exports = __webpack_public_path__ + "img/编码.c9197edb.svg";